import Vue from 'vue';
import Component from './Main';

const Constructor = Vue.extend(Component);

export const LoginBox = function (option = {}) {
  let instance = new Constructor({
    data: option
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  return instance
};



// WEBPACK FOOTER //
// ./src/components/global/LoginBox/index.js